export const DIMENSIONS_DEFAULT_VALUES = {
  WIDTH: '0',
  LENGTH: '0',
  LAYER_THICKNESS: '0',
  AREA: '0',
  HEIGHT: '0',
  DOORS_COUNT: '1',
};
